import { createLogger, toBanner } from '@lglp/prismic-client';

import { compact, unprefix } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { HubNewsroom } from '../../../../types/page/hub-newsroom';
import { processSlices } from '../../slices';
import hubSlice from '../../slices/hub/hub';
import { pageEntity } from './internal';

const processHubNewsroom = (entity: any): HubNewsroom => {
  const { logger } = createLogger();
  return compact({
    uid: DocumentType.HUB_NEWSROOM,
    type: DocumentType.HUB_NEWSROOM,
    banner: toBanner(unprefix('header', entity.data), logger),
    body: processSlices(
      {
        hub: hubSlice(DocumentType.HUB_NEWSROOM),
      },
      entity.data?.body_slices
    ),
  });
};

export const HubNewsroomEntity = pageEntity<HubNewsroom>(
  DocumentType.HUB_NEWSROOM,
  {
    processStrategy: processHubNewsroom,
  }
);
